<template>
  <div class="app-container">
    <div class="filter-head">
      <el-button type="primary" @click="handleAddTable">新增</el-button>
      <div class="status-filter">
        <el-input
          style="max-width: 260px; margin-right: 8px;"
          v-model="listQuery.title"
          placeholder="问卷名称"
          clearable
        ></el-input>
        <div class="select">
          <el-select v-model="listQuery.state" placeholder="状态" clearable>
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" @click="handleFilter">搜索</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        v-loading="listLoading"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
      >
        <el-table-column type="index" label="序号" width="95" align="center" />
        <el-table-column prop="id" label="ID" width="95" align="center" />
        <el-table-column
          prop="title"
          label="问卷"
          min-width="110"
          align="center"
        />
        <el-table-column prop="state" label="状态" width="100" align="center">
          <template #default="{ row: { state } }">
            <el-tag :type="state == 1 ? 'primary' : 'warning'">{{
              state === 1 ? '上架' : '下架'
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditTable(scope.row)"
              >编辑</el-button
            >

            <el-button
              v-if="scope.row.state === 1"
              type="warning"
              size="mini"
              @click="handleForbid(scope.row.id, '下架')"
              >下架</el-button
            >

            <el-button
              v-else
              size="mini"
              type="primary"
              @click="handleForbid(scope.row.id, '上架')"
              >上架
            </el-button>
            <el-button
              size="mini"
              type="info"
              @click="handleCopyTable(scope.row)"
              >复制问卷</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <TableActionModal
      :show.sync="modalVisible"
      :type="activeModalType"
      :editData="editData"
      @onUpdate="onTableActionModalSubmit"
    />
  </div>
</template>

<script>
import { questionnaire } from '@/api/basic'
import TableActionModal from './components/TableActionModal.vue'

export default {
  data: () => ({
    selectOptions: [
      {
        value: 1,
        label: '上架',
      },
      {
        value: 0,
        label: '下架',
      },
    ],
    listLoading: false,
    tableData: [],
    total: null,
    listQuery: {
      page: 1,
      limit: 10,
      title: '',
      state: null,
    },
    modalVisible: false,
    activeModalType: 'add',
    editData: null,
  }),
  components: { TableActionModal },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await questionnaire.list(this.listQuery)
      this.tableData = data.data
      this.total = data.total
      this.listLoading = false
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleCopyTable(data) {
      this.editData = data
      this.activeModalType = 'copy'
      this.modalVisible = true
    },
    // 表格操作
    handleEditTable(data) {
      this.editData = data
      this.activeModalType = 'edit'
      this.modalVisible = true
    },
    setActiveModalType(type) {
      this.activeModalType = type
    },
    handleForbid(id, text) {
      this.$confirm('此操作将' + text + '该问卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await questionnaire.changeState(id)
          this.getList()
        } catch {
          this.$message.error('操作失败!')
        }
      })
    },
    // 分页操作
    handleSizeChange(limit) {
      this.listQuery.limit = limit
      this.getList()
    },
    handleCurrentChange(page) {
      this.listQuery.page = page
      this.getList()
    },
    // 添加数据
    handleAddTable() {
      this.editData = null
      this.activeModalType = 'add'
      this.modalVisible = true
    },
    onTableActionModalSubmit() {
      this.getList()
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style scoped lang="scss">
.filter-head {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .status-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      margin-right: 8px;
    }
  }
}

.table {
  margin-top: 10px;
}
</style>
